module.exports = __webpack_public_path__ + "static/media/icon-credit.e3427cb4.svg";